import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "home container" }
const _hoisted_2 = {
  key: 0,
  class: "current-position"
}
const _hoisted_3 = { class: "position-icon" }
const _hoisted_4 = { class: "position-infos" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "mechanic-infos"
}
const _hoisted_7 = { class: "mechanic-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "mechanic-time" }
const _hoisted_10 = { class: "mechanic-time" }
const _hoisted_11 = { class: "mechanic-disclaimer" }
const _hoisted_12 = {
  key: 2,
  class: "current-position no-data-position"
}
const _hoisted_13 = { class: "home-nav" }
const _hoisted_14 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_icon_base = _resolveComponent("icon-base")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      "is-home": true,
      title: _ctx.t('demand.taken')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.depannageInfo != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_icon_base, {
                "icon-name": "MapLocation",
                "icon-label": "localisation",
                width: "24",
                height: "24",
                class: "icon"
              }),
              _createElementVNode("strong", null, _toDisplayString(_ctx.t('position.yours')), 1)
            ]),
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", null, _toDisplayString(_ctx.t('position.highway')) + " " + _toDisplayString(_ctx.depannageInfo?.autoroute), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.depannageInfo?.sens), 1),
              (_ctx.getPositionInHighway !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_ctx.getPositionInHighway), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.depannageInfo != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.t('depannage.garage')) + " " + _toDisplayString(_ctx.depannageInfo?.nomSmsDep), 1),
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.t('depannage.encounter')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('depannage.departure')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.toHourString(_ctx.depannageInfo?.dateHeurePriseEnCharge)), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t('depannage.arrival')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.toHourString(_ctx.depannageInfo?.dateHeureArriveeEstimee)), 1)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('depannage.disclaimer')), 1)
          ]))
        : _createCommentVNode("", true),
      (
        _ctx.noDataMessage != null && _ctx.noDataMessage != '' && _ctx.depannageInfo == null
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t(_ctx.noDataMessage)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (navItem, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: "nav-item"
          }, [
            _createVNode(_component_router_link, {
              to: navItem.url,
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createElementVNode("a", {
                  href: href,
                  onClick: ($event: any) => (_ctx.initFullScreen(navigate, $event)),
                  class: "nav-link"
                }, [
                  _createTextVNode(_toDisplayString(navItem.title) + " ", 1),
                  (navItem.icon)
                    ? (_openBlock(), _createBlock(_component_icon_base, {
                        key: 0,
                        "icon-name": navItem.icon,
                        "icon-label": navItem.title,
                        width: "48",
                        height: "48",
                        class: "icon"
                      }, null, 8, ["icon-name", "icon-label"]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_14)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ]))
}